module.exports = __webpack_public_path__ + "img/selected-onis-royale.bea5632b.webp";